export default [

    {
        title: 'Замеры',
        icon: 'ListIcon',
        route: 'measurements-measurement-list',
        action: 'read',
        resource: 'measurement',
    },
]
